import React from 'react';
import { BatteryLowIcon, SmartphoneIcon, FlameIcon, TimerIcon, RepeatIcon, MoonStarIcon } from 'lucide-react';
import { painPoints } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
const icons = {
  battery: BatteryLowIcon,
  phone: SmartphoneIcon,
  flame: FlameIcon,
  timer: TimerIcon,
  repeat: RepeatIcon,
  moon: MoonStarIcon
};
export function PainPoints() {
  return <section className="bg-lavender px-4 py-14" data-id="element-186" data-mp="1xwgbst9fodla">
      <div className="mx-auto max-w-4xl" data-id="element-187" data-mp="21zlaslub1x56">
        <SectionHeading title="Do any of these situations sound familiar?" subtitle={<>If you answer <strong className="text-plum" data-id="element-189" data-mp="1o1oelqjrjsr1">YES</strong> to any of them… this system was created for you.</>} data-id="element-188" data-mp="220o22uvji1lm" />
        <ul className="mt-8 grid gap-3 md:grid-cols-2" data-id="element-190" data-mp="3idl77mtxz4no">
          {painPoints.map(p => {
          const Icon = icons[p.icon];
          return <li key={p.text} className="flex items-start gap-4 rounded-2xl bg-white p-4 shadow-sm" data-id="element-191" data-mp="3nc5wwsbki5xv">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-plum" data-id="element-192" data-mp="1yz3yv3vluejh">
                  <Icon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-193" data-mp="1u1bvndpif5zz" />
                </span>
                <p className="text-base leading-relaxed text-ink" data-id="element-194" data-mp="27s762ufnpv5o">{p.text}</p>
              </li>;
        })}
        </ul>
        <CtaButton className="mt-10" label="I want a simple nighttime routine" data-id="element-195" data-mp="1g1t15npmft65" />
      </div>
    </section>;
}